import { render } from "./ReasonList.vue?vue&type=template&id=74e403be&scoped=true"
import script from "./ReasonList.vue?vue&type=script&lang=js"
export * from "./ReasonList.vue?vue&type=script&lang=js"

import "./ReasonList.vue?vue&type=style&index=0&id=74e403be&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74e403be"]])

export default __exports__